import RCTooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import * as React from 'react';
import styled from 'styled-components';
import devices from "../State/Devices";
import { QuestionMark } from './Icons';

interface InterfaceTooltipProps {
    text: React.ReactNode;
    position: 'left' | 'right',
    className?: string,
}

const ContentWrapper = styled.div`
    max-width: 50vw;
    
    @media ${devices.tablet} {
        max-width: 70vw;
    }

    @media ${devices.mobileL} {
        max-width: 90vw;
    }
`;

class Tooltip extends React.Component<InterfaceTooltipProps, any> {
    public render() {
        const { text } = this.props;
        const content = (
            <ContentWrapper>{text}</ContentWrapper>
        );
        return (
            <RCTooltip trigger={['hover']} overlay={content} arrowContent={<div className="rc-tooltip-arrow-inner" />}>
                <QuestionMark/>
            </RCTooltip>
        );
    }
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/Components/Tooltip.tsx